var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClasses},[_c('data-loader',_vm._g({attrs:{"component":_vm.component,"options":_vm.options,"hide-loading-label":true}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }